import { useState } from 'react';
import { Button } from 'devextreme-react/button';
import { LoadPanel } from 'devextreme-react/load-panel';
import { custom } from 'devextreme/ui/dialog';
import notify from 'devextreme/ui/notify';
import { getAuthorizationTokenAsync } from '~/helpers/data';
import './external-mail-system.scss';

export function ExternalMailSystem(props) {
  const { statusMessage, hasError, addNewMode, entityId, entityType } = props;
  const [showLoadingPanel, setShowLoadingPanel] = useState(false);

  const headers = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'Access-Control-Allow-Credentials': true,
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, DELETE',
  }

  async function showAuditDialog() {
    try {
      setShowLoadingPanel(true);
      const response = await getData(`${window.env.apiEndpoint}/api/v1/DistributionList/Audit`, { Id: entityId, entityType: entityType });
      setShowLoadingPanel(false);
      if (response.ok) {
        const data = JSON.parse(await response.text());

        let div1 = `<strong>Missed In MailSystem</strong><br><br><div style='max-height:100px;overflow-y:auto;'>${data.EmailsInEpitomeAndNotInMailSystem.join('<br>')}</div>`;
        let div2 = `<strong>Missed In Epitome</strong><br><br><div style='max-height:100px;overflow-y:auto;'>${data.EmailsInMailSystemAndNotInEpitome.join('<br>')}</div>`;
        let html = `<strong>Email Count in Epitome: ${data.EmailsCountInEpitome}<br><p>Email Count in Mail System: ${data.EmailsCountInMailSystem}</p></strong>${div1}<br>${div2}`;

        let dialog = custom({
          title: "Audit Result",
          messageHtml: html,

          buttons: [{
            text: "Re-Sync.",
            hint: "Re-Sync. the distribution list.",
            onClick: async (e) => {
              try {
                e.component.option("disabled", true);
                setShowLoadingPanel(true);
                const response = await postData(`${window.env.apiEndpoint}/api/v1/ExternalMailSystem/ReCreateDistributionList`, entityId);
                setShowLoadingPanel(false);
                if (response.ok) {
                  notify({ message: 'Re-Create distribution list command has been issued successfully.', shading: true }, 'success');
                }
              } catch (e) {
                notify({ message: `Server Error Status:${e.message}`, shading: true }, 'error');
              }
            }
          },
          {
              text: 'Refresh',
              onClick: async () => {
                await showAuditDialog();
              }
          },
          {
            text: "Close",
            onClick: () => {
              dialog.hide();
            }
          }
          ]
        });
        dialog.show();
      }
    }
    catch (e) {
      notify({ message: `Server Error Status:${e.message}`, shading: true }, 'error');
    }
  }

  return (
    !addNewMode &&
    <div className="container">
      <div className={hasError ? "errorStatusMessage" : "statusMessage"}>
        {hasError ? "" : "Ok"}
      </div>
      <div>
        <LoadPanel
          shadingColor="rgba(0,0,0,0.4)"
          visible={showLoadingPanel}
        />
        <Button
          visible={hasError}
          text="Retry"
          type="danger"
          hint={statusMessage}
          onClick={async (btn) => {
            try {
              btn.component.option("disabled", true);
              setShowLoadingPanel(true);
              const response = await postData(`${window.env.apiEndpoint}/api/v1/ExternalMailSystem/RetryLastCommand`, `${entityId}#${entityType}`);
              btn.component.option("disabled", false);
              setShowLoadingPanel(false);
              if (response.ok) {
                notify({ message: 'Retry command has been issued successfully.', shading: true }, 'success');
              }
            } catch (e) {
              notify({ message: `Server Error Status:${e.message}`, shading: true }, 'error');
            }
          }}
        />
        <Button
            visible={(entityType === 'CommitteeDistributionList' || entityType === 'CSRRoleDistributionList' || entityType === 'DivisionDistributionList' || entityType === 'SchoolDistributionList')}
          text="Audit"
          type="success"
          hint="Audit the distribution list."
            onClick={async () => {
              await showAuditDialog();
          }}
        />
      </div>
    </div>
  );

  async function postData(url, bodyString) {
    const token = await getAuthorizationTokenAsync();
    const response = await fetch(url, {
      method: "POST",
      headers: new Headers({
        'Authorization': `Bearer ${token.accessToken}`,
        ...headers,
      }),
      body: JSON.stringify(bodyString),
    });

    return response;
  }

  async function getData(url, parameters) {
    const token = await getAuthorizationTokenAsync();
    const response = await fetch(`${url}?${new URLSearchParams(parameters)}`, {
      method: "Get",
      headers: new Headers({
        'Authorization': `Bearer ${token.accessToken}`,
        ...headers,
      }),
    });

    return response;
  }
}